<template>
  <div class="h-screen w-screen bg-arch-bg bg-cover bg-center overflow-hidden flex flex-col print:h-auto print:overflow-visible print:bg-white font-sans">
    <!-- 全局背景遮罩改为亮色 (bg-white/85) -->
    <div class="h-full w-full bg-white/85 flex flex-col print:block print:bg-white">
      
      <!-- 顶部导航栏 (替换为半透明橙色渐变，降低饱和度) -->
      <nav class="shrink-0 w-full flex justify-between items-center px-8 py-4 bg-gradient-to-b from-[#e09f5b]/80 to-[#e09f5b]/20 z-50 print:hidden shadow-sm">
        
        <!-- 左侧：返回首页入口 -->
        <router-link to="/" class="flex items-center space-x-3 hover:opacity-80 transition cursor-pointer">
          <img src="./assets/logo.png" alt="SEU Logo" class="h-10 w-auto drop-shadow-sm" />
          <img src="./assets/agent_icon.png" alt="Agent Icon" class="h-8 w-auto drop-shadow-sm" />
          <div class="hidden md:flex flex-col">
            <span class="text-xl font-title-heavy text-gray-900 drop-shadow-sm tracking-wide">绘真建筑</span>
          </div>
        </router-link>
        
        <!-- 右侧区域：导航入口 + 登录/用户信息 -->
        <div class="flex items-center space-x-6">
          
          <!-- 全局功能导航 (替换为纯色线条 Icon) -->
          <div class="hidden md:flex items-center space-x-4 text-sm font-bold tracking-wider">
            <router-link to="/search" class="text-gray-800 px-4 py-2 rounded-full border border-transparent hover:border-white/50 hover:bg-white/30 hover:text-white transition flex items-center space-x-2" active-class="!border-white !text-white bg-white/40 shadow-sm">
              <svg xmlns="[http://www.w3.org/2000/svg](http://www.w3.org/2000/svg)" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
              <span>案例检索</span>
            </router-link>
            <router-link to="/planning" class="text-gray-800 px-4 py-2 rounded-full border border-transparent hover:border-white/50 hover:bg-white/30 hover:text-white transition flex items-center space-x-2" active-class="!border-white !text-white bg-white/40 shadow-sm">
              <svg xmlns="[http://www.w3.org/2000/svg](http://www.w3.org/2000/svg)" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
              </svg>
              <span>智能策划</span>
            </router-link>
          </div>

          <div class="w-[1px] h-6 bg-gray-400 mx-2"></div>

          <!-- 登录/登出与用户信息 -->
          <div class="flex items-center">
            <router-link v-if="!globalState.currentUser" to="/login" class="text-white cursor-pointer bg-white/20 px-5 py-2 rounded-full border border-white hover:bg-white hover:text-[#e09f5b] transition text-sm tracking-widest flex items-center space-x-2 shadow-sm">
              <span>👤</span> <span>登录</span>
            </router-link>
            <div v-else class="flex items-center space-x-4 bg-white/20 px-4 py-1.5 rounded-full border border-white shadow-sm">
              <span class="text-sm text-white flex items-center space-x-2 font-bold">
                <span>👤</span> <span>{{ globalState.currentUser }}</span>
              </span>
              <div class="w-[1px] h-4 bg-gray-300"></div>
              <button @click="handleLogout" class="text-xs text-white hover:text-red-500 transition">登出</button>
            </div>
          </div>
          
        </div>
      </nav>
      
      <!-- 路由页面展示区 -->
      <main class="flex-1 w-full min-h-0 relative flex justify-center print:overflow-visible print:block print:p-0">
        <router-view></router-view>
      </main>
      
      <!-- 全局底部版权 (调整为浅色) -->
      <footer v-if="route.path !== '/'" class="shrink-0 w-full text-center py-4 text-xs text-gray-400 bg-white/80 backdrop-blur-sm border-t border-gray-200 print:hidden">
        <p>© 2026 绘真建筑 | 建筑案例大模型 - 智能建筑设计助手</p>
        <p class="mt-1 opacity-60">Powered by Qwen & Milvus</p>
      </footer>
    </div>
  </div>
</template>

<script setup lang="ts">
import { globalState, logoutUser } from './store';
import { useRouter, useRoute } from 'vue-router';

const router = useRouter();
const route = useRoute();

const handleLogout = () => {
  logoutUser();
  router.push('/login');
};
</script>